module.exports = __webpack_public_path__ + "Body_MetalRoughness.114706f.basis";